module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/017-f671752e4b4eb186f3c40bf6baede6db.jpg";